import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import TableHeadTableCell from '../../../../../../../../components/TableHeadTableCell';

export class WorkTypesTableHead extends React.PureComponent<*> {
    render() {
        return (
            <Table.Header
                // HACK inline styles
                style={{
                    fontSize: 14
                }}
            >
                <Table.Row>
                    <TableHeadTableCell
                        label="Name"
                        value="name"
                        defaultSort="name_ascending"
                    />
                    <TableHeadTableCell
                        label="Area Type"
                        value="entityType.name"
                        defaultSort="name_ascending"
                    />
                    <TableHeadTableCell
                        label="Task Type"
                        value="isPieceRate"
                        defaultSort="name_ascending"
                    />
                    <TableHeadTableCell
                        label="Payroll Code"
                        value="payrollCode"
                        defaultSort="name_ascending"
                    />
                    <Table.HeaderCell />
                </Table.Row>
            </Table.Header>
        );
    }
}

export default WorkTypesTableHead;
